import { render, staticRenderFns } from "./ownmessage.vue?vue&type=template&id=767f37eb&scoped=true&"
import script from "./ownmessage.vue?vue&type=script&lang=js&"
export * from "./ownmessage.vue?vue&type=script&lang=js&"
import style0 from "./ownmessage.vue?vue&type=style&index=0&id=767f37eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f37eb",
  null
  
)

export default component.exports